import Swiper from 'swiper/bundle'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class ImgLink {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.splitLinesText = new SplitText(this.el.querySelectorAll('.img-link--text'), { type: 'words', mask: 'lines' })

    this.init()
  }

  init() {
    this.initSwiper()
    this.initDesktop()
    this.titleAnimation()
    this.contentAnimation()
  }

  initSwiper() {
    const swiperEl = this.el.querySelector('.img-link--slider')
    if (!swiperEl) return
    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      grabCursor: true,
    })
  }

  initDesktop() {
    this.el.querySelector('#img-0')?.classList.add('is-active')
    this.el.querySelector('#text-0')?.classList.add('is-active')
    this.el.querySelector('#title-0')?.classList.add('is-active')

    this.el.querySelectorAll('.img-link--item').forEach(item => {
      item.addEventListener('mouseenter', () => {
        this.el.querySelectorAll('.img-link--item').forEach(t => t.classList.remove('is-active'))
        this.el.querySelectorAll('.img-link--wrapper-content, .img-link--img').forEach(el => el.classList.remove('is-active'))

        const index = item.id.replace('title-', '')
        this.el.querySelector(`#text-${index}`)?.classList.add('is-active')
        this.el.querySelector(`#img-${index}`)?.classList.add('is-active')
        item.classList.add('is-active')
      })
    })
  }

  titleAnimation() {
    this.el.querySelectorAll('.img-link--title').forEach(title => {
      const split = new SplitText(title, { type: 'words', mask: 'lines' })

      gsap.set(split.words, { y: 24, opacity: 0 })

      gsap.to(split.words, {
        y: 0,
        opacity: 1,
        stagger: 0.07,
        ease: 'power3.out',
        duration: 1,
        scrollTrigger: {
          trigger: title,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      })
    })
  }

  contentAnimation() {
    this.splitLinesText.words.forEach(word => {
      gsap.set(word, { y: 24, opacity: 0 })

      gsap.to(word, {
        stagger: 0.07,
        scrollTrigger: {
          trigger: word,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        ease: 'power3.out',
        opacity: 1,
        y: 0,
        duration: 1,
      })
    })
  }
}
